import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

// External reviewer = strictly read-only. The backend is the real gate; this interceptor gives
// immediate, friendly feedback and stops accidental mutating calls from the UI.
let _readOnly = false;
export function setReadOnly(v) { _readOnly = !!v; }

// Attach token from localStorage as fallback for httpOnly cookie
let _wpRev = null;
export function setWpRev(rev) { _wpRev = rev || null; }
api.interceptors.request.use((cfg) => {
    const t = localStorage.getItem("qube_token");
    if (t) cfg.headers.Authorization = `Bearer ${t}`;
    const method = (cfg.method || "").toLowerCase();
    const isWrite = ["post", "put", "patch", "delete"].includes(method);
    const url = cfg.url || "";
    if (_readOnly && isWrite && !/\/auth\//.test(url)) {
        // Stay silent for background heartbeats/acks so the reviewer isn't spammed; toast only real actions.
        const background = /\/presence$|\/notifications\/(read-all|[^/]+\/read)$|\/refresh$/.test(url);
        if (!background) toast.error("External reviewer — read-only access. This action is disabled.");
        return Promise.reject({ config: cfg, readOnly: true, response: { status: 403, data: { detail: "External reviewer has read-only access and cannot change data." } } });
    }
    // Optimistic-concurrency stamp for working-paper writes
    if (isWrite && _wpRev && /\/working-papers\//.test(url) && !/\/presence$/.test(url)) {
        cfg.headers["x-wp-rev"] = _wpRev;
    }
    return cfg;
});

export function fmtErr(detail) {
    if (detail == null) return "Something went wrong.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export default api;
